import Hero from './components/hero/Hero';
import { Routes, Route } from 'react-router-dom';
import Story from './components/story/Story';
import Join from './components/join/Join';
import Mint from './components/mint/Mint';
import { useState, useEffect } from 'react';
import Connect from './components/connect/Connect';
function App() {
  const [theme, setTheme] = useState(false);

  useEffect(() => {
    const time = new Date().getHours();
    if (time >= 0 && 18 >= time) {
      setTheme(false);
    } else if (19 <= time && 23 >= time) {
      setTheme(true);
    }
  }, []);

  return (
    <div>
      <Routes>
        <Route exact path="/" element={<Hero />}></Route>
        <Route
          exact
          path="/story"
          element={
            <Story
              mod={theme}
              changeTheme={() => {
                setTheme(!theme);
              }}
            />
          }
        ></Route>
        <Route
          exact
          path="/join"
          element={
            <Join
              mod={theme}
              changeTheme={() => {
                setTheme(!theme);
              }}
            />
          }
        ></Route>
        <Route
          exact
          path="/mint"
          element={
            <Connect
              mod={theme}
              changeTheme={() => {
                setTheme(!theme);
              }}
            />
          }
        ></Route>
      </Routes>
    </div>
  );
}

export default App;
